import React, { useState, useEffect, useRef } from "react";
import { ContentWrapper } from "./Tasks.styled";
import { CardPanel, Card, IconHighlight, Button, Skeleton, WidgetEmptyErrorPlaceholder } from "@ann/web-components";
import { TaskContent } from "./components";
import ScrollableCardContent from "../ScrollableCardContent";

const Tasks = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hasData, setHasData] = useState(true);
  const timeoutRef = useRef(null);

  const clearExistingTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const fetchData = () => {
    setIsLoading(true);
    setError(null);

    clearExistingTimeout();

    timeoutRef.current = setTimeout(() => {
      const random = Math.random();
      if (random < 0.1) {
        setError(true);
        setHasData(false);
      } else if (random < 0.3) {
        setError(false);
        setHasData(false);
      } else {
        setError(false);
        setHasData(true);
      }
      setIsLoading(false);
      timeoutRef.current = null;
    }, 2000);
  };

  useEffect(() => {
    fetchData();

    return () => {
      clearExistingTimeout();
    };
  }, []);

  if (isLoading) {
    return <Skeleton height="571px" width="100%" />;
  }

  if (error) {
    return (
      <Card size='large'>
        <CardPanel isExpandable={false} openDefault={true}>
          <CardPanel.Content>
            <WidgetEmptyErrorPlaceholder
              buttonText="Retry"
              icon="error"
              message="We couldn't load your tasks. Please try again."
              onClick={fetchData}
              showButton
              title="Something went wrong"
            />
          </CardPanel.Content>
        </CardPanel>
      </Card>
    );
  }

  if (!hasData) {
    return (
      <Card size='large'>
        <CardPanel isExpandable={false} openDefault={true}>
          <CardPanel.Content>
            <WidgetEmptyErrorPlaceholder
              icon="task"
              message="You have no pending tasks right now. New tasks will show up here as soon as they're assigned."
              showButton={false}
              title="No Current Tasks"
            />
          </CardPanel.Content>
        </CardPanel>
      </Card>
    );
  }

  return (
    <Card size='large'>
      <CardPanel isExpandable={false}>
        <CardPanel.Header title="Tasks" subtitle="(6)">
          <CardPanel.Header.LeftSlot>
            <IconHighlight
              icon="task"
              bgColor="primary"
              iconColor="primary"
              size="medium"
            />
          </CardPanel.Header.LeftSlot>
        </CardPanel.Header>
        <CardPanel.Content>
          <ScrollableCardContent>
            <ContentWrapper>
              <TaskContent />
            </ContentWrapper>
          </ScrollableCardContent>
        </CardPanel.Content>
        <CardPanel.Actions>
          <Button size="medium" type="secondary" label="View all" />
        </CardPanel.Actions>
      </CardPanel>
    </Card>
  );
};

export default Tasks;
